import { useTranslation } from 'react-i18next'
import { LocalizationHook, SupportedLocale } from './types'

export function useLocalization<K extends string>(): LocalizationHook<K> {
  const { t, i18n } = useTranslation()

  return {
    localize: t,
    setLocale: (locale) => {
      if (i18n.language !== locale) {
        void i18n.changeLanguage(locale)
      }
    },
    getCurrentLocale: () => i18n.language as SupportedLocale,
  }
}
